"use client";
import React from "react";

function Footer() {
  return (
    <footer className="text-center py-4 mt-5 footer">
      Visit our{" "}
      <a
        href="https://help.striketru.com/portal/en/kb/akeneo-pim-connector-for-shopify"
        target="_blank"
        rel="noopener noreferrer"
      >
        Help Center
      </a>{" "}
       to review the documentation or create a ticket: 
       <a
        href="https://help.striketru.com/portal/en/signup"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://help.striketru.com/portal/en/signup
      </a>
      .
    </footer>
  );
}

export default Footer;
